import { createSelector } from 'reselect';
import {
  FORM_KEYS, CLIENT_CLASSIFICATION, TYPE_OF_INVESTMENT, QUALIFIED_TYPE_OF_INVESTMENT, TAGS_TYPE,
} from 'shared/constant';
import utils from 'shared/helpers/utils';
import { get, isEmpty } from 'lodash';
// import moment from 'moment';

const {
  CLIENT_DETAILS, PEP, BANK, SOURCE_OF_WEALTH, ASI, CLIENT_PROFILE_FORM,
  FATCA, CRS, ID_PASSPORT, FORM_OPTIONS, AGREEMENT, APPLICANT,
} = FORM_KEYS;

const getApplicantId = state => state.applicantRootReducer.applicantReducer[APPLICANT.APPLICANT_ID];
const getApplicantPhone = state => state.applicantRootReducer.applicantReducer[APPLICANT.PHONE_NUMBER];
const getApplicantIsEmailSent = state => state.applicantRootReducer.applicantReducer[APPLICANT.IS_EMAIL_SENT];
const getPaciFrontStatus = state => state.applicantRootReducer.applicantReducer.paciFrontStatus;
const getReworkStatus = state => state.applicantRootReducer.applicantReducer.rework;

const getFormOptions = state => state.formOptionReducer[FORM_OPTIONS];
const getIsFormSubmitted = state => state.formOptionReducer.isSubmitClicked;

const getAuthData = state => state.authReducer;
const getPhoneNumber = state => state.authReducer.phoneNumber;
const getAuthEmailAddress = state => state.authReducer.emailAddress;
const getAuthIsUseExisting = state => state.authReducer.isUserExisting;
const getToken = state => state.authReducer.token;
const getIsAuthenticated = state => state.authReducer.isAuthenticated;
const getDsUserDetail = createSelector(
  getAuthData,
  authData => (!isEmpty(authData.dsUserDetail) ? JSON.parse(authData.dsUserDetail) : ''),
);

const getFullName = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.FULL_NAME];
const getIsWithCivilId = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.IS_WITH_CIVIL_ID];
const getCivilId = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.CIVIL_ID];
const getPassportId = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.PASSPORT_ID];
const getSelfie = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.SELFIE];
const getCivilIdFront = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.CIVIL_ID_FRONT];
const getCivilIdBack = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.CIVIL_ID_BACK];
const getPassport = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.PASSPORT];
const getIsTobeEmailed = state => state.applicantRootReducer.idPassportReducer[ID_PASSPORT.TO_BE_EMAILED];
const isIdsUploaded = createSelector(
  [getSelfie, getCivilIdFront, getCivilIdBack, getPassport],
  (selfie, civilIdFront, civilIdBack, passport) => !!(selfie && civilIdFront && civilIdBack && passport),
);

const getClientDetails = state => state.applicantRootReducer.personalInformationReducer.clientDetails;
const getClientClassification = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.CLIENT_CLASSIFICATION];
const getMutualFundQualified = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.MUTUAL_FUND_QUALIFIED];
const getInvestmentStrategy = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.INVESTMENT_STRATEGY];
const getAssetAllocation = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.ASSET_ALLOCATIONS];

const getTypeOfInvestment = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.TYPE_OF_INVESTMENT];
const getProduct = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.PRODUCT];
const getQualifiedInvestor = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.QUALIFIED_INVESTOR];
const getNationality = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.NATIONALITY];
const getDateOfBirth = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.DATE_OF_BIRTH];
const getCityOfBirth = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.CITY_OF_BIRTH];
const getCountryOfBirth = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.COUNTRY_OF_BIRTH];
const getOccupation = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.OCCUPATION];
const getHomeAddress = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.HOME_ADDRESS];
const getCountryOfResidence = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.COUNTRY_OF_RESIDENCE];
const getEmailAddress = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.EMAIL_ADDRESS];
const getMobile = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.MOBILE];
const getEmployer = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME];
const getPosition = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.POSITION];
const getOfficeAddress = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.OFFICE_ADDRESS];
const getInvestedAmount = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.INVESTED_AMOUNT];
const getInvestedUnitToAmount = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.INVESTED_UNIT_TO_AMOUNT];
const getEducationLevel = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.EDUCATION_LEVEL];
const getOtherEducationLevel = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.OTHER_EDUCATION_LEVEL];
const getOtherCivilIdOrPassport = state => state.applicantRootReducer.personalInformationReducer.clientDetails[CLIENT_DETAILS.OTHER_NATIONALITY_PASSPORT];

const getFormatedDateOfBirth = createSelector([getDateOfBirth], dob => (dob).toString().replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3'));
const getAge = createSelector([getDateOfBirth], dob => dob && utils.calculateAge((dob).toString().replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3')));

const getisPep = state => state.applicantRootReducer.personalInformationReducer.pep[PEP.IS_PEP];
const getPepList = state => state.applicantRootReducer.personalInformationReducer.pep[PEP.BENEFICIARIES];

const getBankDetails = state => state.applicantRootReducer.personalInformationReducer.bankDetails;
const getBankName = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.BANK_NAME];
const getOtherBankName = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.OTHER_BANK_NAME];
const getDomicileCountry = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.DOMICILE_COUNTRY];
const getAccountName = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.ACCOUNT_NAME];
const getIban = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.IBAN];
const bankAcctFormat = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.BANK_ACCT_FORMAT];
const getswift = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.SWIFT_NUMBER];
const getRoutingNumber = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.ROUTING_NUMBER];
const getBankAcctFormat = createSelector(
  [bankAcctFormat],
  acctFormat => (acctFormat === true ? 'iban' : 'nonIban'),
);
const getCurrency = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.CURRENCY];
const getUsingKNET = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.USING_KNET];
const getCardInfo = state => state.applicantRootReducer.personalInformationReducer.bankDetails[BANK.CARD_INFO];

const getSourceOfWealthDetails = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth;
const getEstimatedWealth = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.ESTIMATED_WEALTH];
const getWealthApproxVal = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL];
const getSourceOfWealth = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.WEALTH_FUNDS];
// source of fund selection's other fields
const getTotalYrsExp = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.TOTAL_YRS_EXP}`, '');
const getDetailOfRel = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.DETAIL_OF_REL}`, '');
const getYrOfInheritance = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.YR_OR_INHERITANCE}`, '');
const getApproxValOfInheritance = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE}`, '');
const getTypeOfAssetMarket = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.TYPE_ASSET_MARKET}`, '');
const getApproxValInvSav = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV}`, '');
const getDetailOfBiz = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.DETAIL_OF_BIZ}`, '');
const getTypeOfActvity = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.TYPE_OF_ACT}`, '');
const getApproxRevenue = state => get(state.applicantRootReducer.personalInformationReducer.sourceOfWealth, `${SOURCE_OF_WEALTH.APPROX_VAL_REV}`, '');
const getOtherSourceOfWealth = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH];
const getNetAssets = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.NET_ASSETS];
const getNetIncome = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.NET_INCOME];
const getNetIncomeApproxVal = state => state.applicantRootReducer.personalInformationReducer.sourceOfWealth[SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL];

const getAsiDetails = state => state.applicantRootReducer.personalInformationReducer.asi;
const getAsiIsPOAholder = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.POA_HOLDER];
const getAsiIsAuthorityToDeal = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.IS_AUTHORITY_TO_DEAL];
const getAsiName = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.NAME];
const getAsiAddress = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.ADDRESS];
const getAsiEmail = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.EMAIL_ADDRESS];
const getAsiNationality = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.NATIONALITY];
const getAsiDOB = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.DOB];
const getFormatedAsiDOB = createSelector([getAsiDOB], dob => (dob).toString().replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3'));
const getAsiOccupation = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.OCCUPATION];
const getAsiPosition = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.POSITION];
const getAsiMobile = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.MOBILE];
const getAsiMobileCC = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.COUNTRY_CODE_MOBILE];
const getAsiHomeNumber = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.HOME_NUMBER];
const getAsiHomeNumberCC = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.COUNTRY_CODE_HOME_NUMBER];
const getAsiEmployer = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.EMPLOYER_BUSINESS_NAME];
const getAsiRelationship = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.RELATIONSHIP_WITH_CLIENT];
const getAsiUSperson = state => state.applicantRootReducer.personalInformationReducer.asi[ASI.IS_AS_US_PERSON];

const getClientProfileFormDetails = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm;
const getWithInvestmentExp = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.WITH_INVESTMENT_EXP];
const getCpfGoal = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.GOAL];
const getCpfInvestmentPurpose = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE];
const getCpfInvestmentPurposeOthers = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE_OTHERS];
const getCpfRiskTolerance = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.RISK_TOLERANCE];
const getCpfInvestmentPreference = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_PREFERENCE];

const getCpfBondsYrs = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_YRS];
const getCpfBondsStrategy = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_STRATEGY];
const getCpfEquitiesYrs = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_YRS];
const getCpfEquitiesStrategy = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_STRATEGY];
// const getCpfDerivativesYrs = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_DERIVATIVES_YRS];
// const getCpfDerivativesStrategy = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_DERIVATIVES_STRATEGY];
const getCpfPrivateEquityYrs = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS];
const getCpfPrivateEquityStrategy = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_STRATEGY];
const getCpfRealEstateYrs = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_YRS];
const getCpfRealEstateStrategy = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_STRATEGY];
const getCpfOtherAlternativeYrs = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS];
const getCpfOtherAlternativeStrategy = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_STRATEGY];
const getCpfIndependentProfAdvice = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INDEPENDENT_PROF_ADVICE];
const getCpfInsiderStatus = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INSIDER_STATUS];
// const getCpfObjectiveTimeHorizon = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_OBJECTIVE_TIME_HORIZON];
// const getCpfAssetClasses = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.ASSET_CLASSES];
// const getCpfMarkets = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.MARKETS];
// const getCpfInvestmentKnowledge = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INVESTMENT_KNOWLEDGE];
const getCpfRestrictions = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.RESTRICTIONS];
const getCpfOtherRestriction = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.OTHER_RESTRICTION];
// const getCpfOtherSector = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.OTHER_SECTOR];
// const getCpfOtherIssuer = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.OTHER_ISSUER];

const getInsiderList = state => state.applicantRootReducer.personalInformationReducer.clientProfileForm[CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST];

const getFatcaData = state => state.applicantRootReducer.fatcaCrsReducer.fatca;
const getFatcaQ1 = state => state.applicantRootReducer.fatcaCrsReducer.fatca[FATCA.FATCA_Q1];
const getFatcaQ2 = state => state.applicantRootReducer.fatcaCrsReducer.fatca[FATCA.FATCA_Q2];
const getFatcaQ3 = state => state.applicantRootReducer.fatcaCrsReducer.fatca[FATCA.FATCA_Q3];
const getFatcaQ4 = state => state.applicantRootReducer.fatcaCrsReducer.fatca[FATCA.FATCA_Q4];
const getFatcaQ5 = state => state.applicantRootReducer.fatcaCrsReducer.fatca[FATCA.FATCA_Q5];
const getFatcaQ6 = state => state.applicantRootReducer.fatcaCrsReducer.fatca[FATCA.FATCA_Q6];
const getFatcaQ2State = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q2}${FATCA.STATE}`];
const getFatcaQ2City = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q2}${FATCA.CITY}`];
const getFatcaQ3Address = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`];
const getFatcaQ3UsPhone = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`];
const getFatcaQ4Address = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`];
const getFatcaQ5Beneficiary = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`];
const getFatcaQ5Nationality = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`];
const getFatcaQ6NameOfPerson = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`];
const getFatcaQ6Nationality = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`];
const getFatcaQ6Address = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`];
const getFatcaQ6UsPhone = state => state.applicantRootReducer.fatcaCrsReducer.fatca[`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`];

const getCrsData = state => state.applicantRootReducer.fatcaCrsReducer.crs;
const getCrsQ1 = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.CRS_Q1];
const getCrsQ2 = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.CRS_Q2];
const getCrsQ3 = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.CRS_Q3];
const getCrsQ4 = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.CRS_Q4];
const getCrsQ5 = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.CRS_Q5];
const getCrsQ6 = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.CRS_Q6];
const getCrsResidentJurisdiction = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.RESIDENT_REPORTABLE_JURISDICTION];
const getCrsResidenceAddress = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.RESIDENCE_ADDRESS];
const getCrsTelephone = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.TELEPHONE_NUMBER];
const getCrsHoldMail = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.HOLD_MAIL];
const getCrsStandingInstruction = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.STANDING_INSTRUCTION];
const getCrsEffectivePoa = state => state.applicantRootReducer.fatcaCrsReducer.crs[CRS.EFFECTIVE_POA];

const getTaxList = state => state.applicantRootReducer.fatcaCrsReducer.countryTax;

const getAofKycAgreement = state => state.agreementReducer[AGREEMENT.AOF_KYC];
const getProfileAgreement = state => state.agreementReducer[AGREEMENT.PROFILE];
const getAcknowledgementAgreement = state => state.agreementReducer[AGREEMENT.NDPF];
const getProposedPlanAgreement = state => state.agreementReducer[AGREEMENT.PROPOSED_PLAN];
const getAofKycProfileSignature = state => state.agreementReducer[AGREEMENT.AOF_KYC_PROFILE_SIGNATURE];
const getNdpfProposedPlanSignature = state => state.agreementReducer[AGREEMENT.NDPF_PROPOSED_PLAN_SIGNATURE];
const getIsAgreementReadyStatus = state => state.agreementReducer[AGREEMENT.IS_AGREEMENT_READY_FOR_QUALIFIED];
const getIsCustomAAUploaded = state => state.agreementReducer[AGREEMENT.IS_CUSTOM_AA_UPLOADED];

const isIdPassportCompleted = createSelector(
  [getFullName, getPassportId, getCivilId, getSelfie, getCivilIdFront, getCivilIdBack, getPassport],
  (name, passportId, civilId, selfie, civilFront, civilBack, passport) => !!(name && passportId && civilId && selfie && civilFront && civilBack && passport),
);

const getAssetAllocationUrl = state => state.applicantRootReducer.applicantReducer.assetAllocationUrl;
const getIrepUrl = state => state.applicantRootReducer.applicantReducer.irepUrl;
const getDpfUrl = state => state.applicantRootReducer.applicantReducer.dpfUrl;
const getCpfUrl = state => state.applicantRootReducer.applicantReducer.cpfUrl;
const getinvestmentStategyAbsoluteUrl = state => state.applicantRootReducer.applicantReducer.investmentStrategyAbsoluteUrl;
const getinvestmentStategyAbsoluteShariaUrl = state => state.applicantRootReducer.applicantReducer.investmentStrategyAbsoluteShariaUrl;
const getinvestmentStategyDividend = state => state.applicantRootReducer.applicantReducer.dividendUrl;
const getCustomUploadedFileUrls = state => state.applicantRootReducer.applicantReducer.customFileUrls;
const getCustomSubPfUrl = state => state.applicantRootReducer.applicantReducer.customSubPfUrl;

// const isPersonalInformationCompleted = createSelector(
//   [getClientDetails]
// )

const getSteps = state => state.stepsReducer.steps;

const isAllStepsCompleted = createSelector(
  [getSteps],
  (steps) => {
    const getCompleted = steps.filter(item => item.isCompleted === true).length;
    return getCompleted === 6;
  },
);

const isFirstAgreementCompleted = createSelector(
  [getSteps, getAofKycAgreement, getProfileAgreement, getAofKycProfileSignature, getReworkStatus],
  (steps, aofKycAgreement, profileAgreement, formAgreementSign, reworkStatus) => {
    const isAofKycAgreed = !!(aofKycAgreement.selected.length === 3);
    const isProfileAgreed = !!(profileAgreement.selected.length === 2);
    const isFormAgreementSigned = !!(formAgreementSign !== '');

    const getCompleted = steps.filter(item => item.isCompleted === true).length;
    // console.log('IS ALL COMPLETED ', getCompleted, getCompleted >= 4, isAofKycAgreed, isProfileAgreed, isFormAgreementSigned, reworkStatus);
    // return getCompleted === 6;

    return !reworkStatus && getCompleted >= 4 && isAofKycAgreed && isProfileAgreed && isFormAgreementSigned;
  },
);

const getRefCode = state => state.applicantRootReducer.applicantReducer.imarkazRefCode;
const getProductCode = state => state.applicantRootReducer.applicantReducer.productCode;
const getCompletionDate = state => state.applicantRootReducer.applicantReducer.completionDate;
const getLastLoggedIn = state => state.applicantRootReducer.applicantReducer.lastLoggedIn;
const getCurrentLoggedIn = state => state.applicantRootReducer.applicantReducer.currentLoggedIn;
const isShowSubcription = createSelector(
  [getClientClassification, getTypeOfInvestment],
  (clientClassification, typeOfInvestment) => (clientClassification === CLIENT_CLASSIFICATION.RETAIL && typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS) || (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS),
);
const getLatestRefCode = state => state.applicantRootReducer.applicantReducer.latestRefCode;

/** FOR PRODUCT CATALOGUE */
const selectedProductCatalogue = state => state.catalogueReducer.selected;
const productCatalogue = state => state.catalogueReducer.data && state.catalogueReducer.data;
const getSelectedProductCard = createSelector(
  [productCatalogue, selectedProductCatalogue],
  (catalogue, selectedId) => {
    const filteredData = catalogue.filter(item => item.id === selectedId);
    if (!filteredData.length || !selectedId) return {};
    const {
      fundName, investmentObjective, productType, geography, bannerSrc, id, isin, currency, annualizedReturn, benchmarkReturn,
      category1, category2, investorType, subscription,
      realEstateType, investmentServiceType, investmentHorizon, targetNetIrr, targetNetMultiple,
    } = filteredData[0];

    const { formatAsPercentage, formatNumberToDecimal } = utils;

    const performanceData = [
      { // Since Inception
        annualizedReturn: formatAsPercentage(formatNumberToDecimal(annualizedReturn.SinceInception)),
        benchmarkReturn: formatAsPercentage(formatNumberToDecimal(benchmarkReturn.SinceInception)),
        annLabel: 'product.annualizedReturn',
      }, { // 5 Years
        annualizedReturn: formatAsPercentage(formatNumberToDecimal(annualizedReturn.M60)),
        benchmarkReturn: formatAsPercentage(formatNumberToDecimal(benchmarkReturn.M60)),
        annLabel: 'product.annualizedReturn',
      }, { // 3 Years
        annualizedReturn: formatAsPercentage(formatNumberToDecimal(annualizedReturn.M36)),
        benchmarkReturn: formatAsPercentage(formatNumberToDecimal(benchmarkReturn.M36)),
        annLabel: 'product.annualizedReturn',
      }, { // 1 Year
        annualizedReturn: formatAsPercentage(formatNumberToDecimal(annualizedReturn.M12)),
        benchmarkReturn: formatAsPercentage(formatNumberToDecimal(benchmarkReturn.M12)),
        annLabel: 'product.1yrReturn',
      }, { // 3 Months
        annualizedReturn: formatAsPercentage(formatNumberToDecimal(annualizedReturn.M3)),
        benchmarkReturn: formatAsPercentage(formatNumberToDecimal(benchmarkReturn.M3)),
        annLabel: 'product.3mReturn',
      },
    ];

    const realEstateData = {
      type: realEstateType !== null ? realEstateType : '-',
      investmentHorizon: investmentHorizon ? `${investmentHorizon}` : '-',
      targetNetIRR: formatAsPercentage(formatNumberToDecimal(targetNetIrr)),
      targetNetMultiple: targetNetMultiple ? `${targetNetMultiple}` : '-',
    };

    const investmentServiceData = {
      type: investmentServiceType || '-',
      investmentHorizon: investmentHorizon ? `${investmentHorizon}` : '-',
      targetNetMultiple: targetNetMultiple ? `${targetNetMultiple}` : '-',
    };

    const tags = [];
    if (category1 !== '') {
      tags.push({
        value: category1.replace(/,/g, ', '),
        type: TAGS_TYPE.CATEGORY1,
      });
    }
    if (category2 !== '') {
      tags.push({
        value: category2.replace(/,/g, ', '),
        type: TAGS_TYPE.CATEGORY2,
      });
    }
    if (investorType !== '') {
      tags.push({
        value: investorType.replace(/,/g, ', '),
        type: TAGS_TYPE.INVESTOR_TYPE,
      });
    }

    const transformedData = {
      fundName: fundName.EN,
      investmentObjective: investmentObjective.EN,
      productType,
      geography: geography.split(','),
      bannerSrc,
      id,
      isin,
      currency,
      performanceData,
      realEstateData,
      investmentServiceData,
      tags,
      subscription,
    };

    return transformedData;
  },
);
const getMinInvestAmountData = createSelector([getFormOptions, productCatalogue], (formOptionsData, productCatalogueData) => {
  const result = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const fund of formOptionsData.productOptions) {
    // eslint-disable-next-line arrow-parens
    const fundInCatalogue = productCatalogueData.find((item) => item.id === fund.id);
    if (fundInCatalogue) {
      let minimumInitialAmount = '';
      let currencyLabel = '';
      if (fundInCatalogue.subscription.MinimumInitialType === 'unit') {
        // eslint-disable-next-line radix
        minimumInitialAmount = Number(fundInCatalogue.nav) * Number(fundInCatalogue.subscription.MinimumInitialAmount);
        currencyLabel = fundInCatalogue.currency;
      } else {
        minimumInitialAmount = fundInCatalogue.subscription.MinimumInitialAmount;
        currencyLabel = fundInCatalogue.subscription.MinimumInitialAmountUnit;
      }
      result.push({
        id: fund.id,
        name: fund.label,
        // eslint-disable-next-line radix
        minimumInitialAmount: Number(minimumInitialAmount),
        currencyLabel,
      });
    }
  }
  return result;
});

const getProductMinInvestAmountData = createSelector(
  [getProduct, getMinInvestAmountData],
  (product, minInvestAmountData) => minInvestAmountData.find(item => item.id === product) || {
    id: '',
    name: '',
    // eslint-disable-next-line radix
    minimumInitialAmount: 1,
    currencyLabel: '',
  },
);

const getLanguage = state => state.languageReducer.language;

const selectors = {
  getApplicantId,
  getApplicantPhone,
  getApplicantIsEmailSent,
  getPaciFrontStatus,

  getRefCode,
  getProductCode,
  getLatestRefCode,
  getFormOptions,
  getIsFormSubmitted,

  // AUTH
  getPhoneNumber,
  getAuthEmailAddress,
  getAuthIsUseExisting,
  getToken,
  getIsAuthenticated,
  getDsUserDetail,

  // ID & CIVIL ID
  getFullName,
  getIsWithCivilId,
  getCivilId,
  getPassportId,
  getSelfie,
  getCivilIdFront,
  getCivilIdBack,
  getPassport,
  getIsTobeEmailed,
  isIdsUploaded,

  // CLIENT DETAILS
  getClientDetails,
  getClientClassification,
  getInvestmentStrategy,
  getAssetAllocation,
  getMutualFundQualified,
  getTypeOfInvestment,
  getProduct,
  getQualifiedInvestor,
  getNationality,
  getDateOfBirth,
  getCityOfBirth,
  getCountryOfBirth,
  getOccupation,
  getHomeAddress,
  getCountryOfResidence,
  getEmailAddress,
  getMobile,
  getEmployer,
  getPosition,
  getOfficeAddress,
  getInvestedAmount,
  getInvestedUnitToAmount,
  getEducationLevel,
  getOtherEducationLevel,
  getOtherCivilIdOrPassport,

  getFormatedDateOfBirth,
  getAge,

  // PEP
  getisPep,
  getPepList,

  // BANK DETAILS
  getBankDetails,
  getBankName,
  getOtherBankName,
  getDomicileCountry,
  getAccountName,
  getIban,
  getBankAcctFormat,
  getswift,
  getRoutingNumber,
  getCurrency,
  getUsingKNET,
  getCardInfo,

  // SOURCE OF WEALTH
  getSourceOfWealthDetails,
  getEstimatedWealth,
  getSourceOfWealth,
  getOtherSourceOfWealth,
  getTotalYrsExp,
  getDetailOfRel,
  getYrOfInheritance,
  getApproxValOfInheritance,
  getTypeOfAssetMarket,
  getApproxValInvSav,
  getDetailOfBiz,
  getTypeOfActvity,
  getApproxRevenue,
  getNetAssets,
  getNetIncome,
  getWealthApproxVal,
  getNetIncomeApproxVal,

  // ASI
  getAsiDetails,
  getAsiIsPOAholder,
  getAsiIsAuthorityToDeal,
  getAsiName,
  getAsiAddress,
  getAsiEmail,
  getAsiNationality,
  getAsiDOB,
  getFormatedAsiDOB,
  getAsiOccupation,
  getAsiPosition,
  getAsiMobile,
  getAsiMobileCC,
  getAsiHomeNumber,
  getAsiHomeNumberCC,
  getAsiEmployer,
  getAsiRelationship,
  getAsiUSperson,

  // CLIENT PROFILE FORM
  getClientProfileFormDetails,
  getWithInvestmentExp,
  getCpfGoal,
  getCpfInvestmentPurpose,
  getCpfInvestmentPurposeOthers,
  getCpfRiskTolerance,
  getCpfInvestmentPreference,
  getCpfBondsYrs,
  getCpfBondsStrategy,
  getCpfEquitiesYrs,
  getCpfEquitiesStrategy,
  // getCpfDerivativesYrs,
  // getCpfDerivativesStrategy,
  getCpfPrivateEquityYrs,
  getCpfPrivateEquityStrategy,
  getCpfRealEstateYrs,
  getCpfRealEstateStrategy,
  getCpfOtherAlternativeYrs,
  getCpfOtherAlternativeStrategy,
  getCpfIndependentProfAdvice,
  getCpfInsiderStatus,
  // getCpfObjectiveTimeHorizon,
  // getCpfAssetClasses,
  // getCpfMarkets,
  // getCpfInvestmentKnowledge,
  getCpfRestrictions,
  getCpfOtherRestriction,
  getInsiderList,

  // getCpfOtherSector,
  // getCpfOtherIssuer,

  // FATCA
  getFatcaData,
  getFatcaQ1,
  getFatcaQ2,
  getFatcaQ3,
  getFatcaQ4,
  getFatcaQ5,
  getFatcaQ6,
  getFatcaQ2State,
  getFatcaQ2City,
  getFatcaQ3Address,
  getFatcaQ3UsPhone,
  getFatcaQ4Address,
  getFatcaQ5Beneficiary,
  getFatcaQ5Nationality,
  getFatcaQ6NameOfPerson,
  getFatcaQ6Nationality,
  getFatcaQ6Address,
  getFatcaQ6UsPhone,

  // CRS
  getCrsData,
  getCrsQ1,
  getCrsQ2,
  getCrsQ3,
  getCrsQ4,
  getCrsQ5,
  getCrsQ6,
  getCrsResidentJurisdiction,
  getCrsResidenceAddress,
  getCrsTelephone,
  getCrsStandingInstruction,
  getCrsHoldMail,
  getCrsEffectivePoa,

  getTaxList,

  getAofKycAgreement,
  getProfileAgreement,
  getAcknowledgementAgreement,
  getProposedPlanAgreement,
  getAofKycProfileSignature,
  getNdpfProposedPlanSignature,
  getIsAgreementReadyStatus,
  isFirstAgreementCompleted,
  getIsCustomAAUploaded,

  isIdPassportCompleted,
  isAllStepsCompleted,
  isShowSubcription,
  getCompletionDate,
  getLastLoggedIn,
  getCurrentLoggedIn,

  // PDFs Url
  getAssetAllocationUrl,
  getIrepUrl,
  getDpfUrl,
  getCpfUrl,
  getinvestmentStategyAbsoluteUrl,
  getinvestmentStategyAbsoluteShariaUrl,
  getCustomUploadedFileUrls,
  getCustomSubPfUrl,
  getinvestmentStategyDividend,

  /** Product Catalogue */
  getSelectedProductCard,
  getMinInvestAmountData,
  getProductMinInvestAmountData,

  getLanguage,
};

export default selectors;
